import {
	RESET_STATE,
	SET_COMPANY_INFO,
	SET_IS_COMPANY_INFO_LOADING,
	SET_IS_ORG_TYPES_LOADING,
	SET_IS_SENDING_ACCREDITATION,
	SET_IS_TAX_RATES_LOADING,
	SET_IS_TAX_SYSTEMS_LOADING,
	SET_ORG_TYPES,
	SET_TAX_RATES,
	SET_TAX_SYSTEMS,
} from './actions';

export const initialState = {
	orgTypes: [],
	isOrgTypesLoading: false,
	taxSystems: [],
	isTaxSystemsLoading: false,
	taxRates: [],
	isTaxRatesLoading: false,
	companyInfo: null,
	isCompanyInfoLoading: false,
	isSendingAccreditation: false,
};

const accreditationCompanyModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_ORG_TYPES:
			return {
				...state,
				orgTypes: payload,
			};
		case SET_IS_ORG_TYPES_LOADING:
			return {
				...state,
				isOrgTypesLoading: payload,
			};
		case SET_TAX_SYSTEMS:
			return {
				...state,
				taxSystems: payload,
			};
		case SET_IS_TAX_SYSTEMS_LOADING:
			return {
				...state,
				isTaxSystemsLoading: payload,
			};
		case SET_TAX_RATES:
			return {
				...state,
				taxRates: payload,
			};
		case SET_IS_TAX_RATES_LOADING:
			return {
				...state,
				isTaxRatesLoading: payload,
			};
		case SET_COMPANY_INFO:
			return {
				...state,
				companyInfo: payload,
			};
		case SET_IS_COMPANY_INFO_LOADING:
			return {
				...state,
				isCompanyInfoLoading: payload,
			};
		case SET_IS_SENDING_ACCREDITATION:
			return {
				...state,
				isSendingAccreditation: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default accreditationCompanyModalReducer;
